import { Component, OnInit } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../modals/auth/login/login.component';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from '../../models/auth.model';
import { AuthService } from '../../core/services/auth.service';
@Component({
  selector: 'fgsn-ecommerce-website-header',
  standalone: true,
  imports: [RouterModule, MatMenuModule, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: LoginResponse | null = null;
  isActive = false;
  assetsConst = assets;
  navMenu = [
    {
      title: 'Home',
      path: ''
    },
    {
      title: 'Category',
      path: '/category-list'
    },
    {
      title: 'About',
      path: '/support/about-us'
    }
  ];

  constructor(
    public dialog: MatDialog,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
        }
      });
  }

  loginModal(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      panelClass: ['modall']
    });
    document.body.style.overflow = 'hidden';
    dialogRef.afterClosed().subscribe(() => {
      document.body.style.overflow = '';
    });
  }

  toggleMenu(): void {
    this.isActive = !this.isActive;
  }
}
